import { render } from "./OldPassword.vue?vue&type=template&id=350a615b&scoped=true"
import script from "./OldPassword.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./OldPassword.vue?vue&type=script&charset=utf-8&lang=js"

import "./OldPassword.vue?vue&type=style&index=0&id=350a615b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350a615b"]])

export default __exports__